module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-stone-path-remnants.ad5a616c.png";